import config from '../config/config'

export const isDesktop = (global) => global && global.innerWidth >= config.breakpoints.lg

export const isMobile = (global) => global && global.innerWidth < config.breakpoints.md

export const isMobileOrTablet = (global) => global && global.innerWidth < config.breakpoints.lg

export const isShortViewport = (global) => global && global.innerHeight < config.breakpoints.md // 768 aligns with 700 where issue begins
